import { MENTION_CLASS as e } from "./constants.js";
import { hasNativeEmojiSupport as t, substituteUnicodeForColonified as n } from "./utils/emoji.js";
import { encodeAttributes as r } from "./utils/attribute-encoding.js";
import { escape as i } from "./utils/escape.js";
import { htmlToTextContent as a, unescape as o } from "./utils/unescape.js";
//#region src/text-serializer.ts
var s = class {
	schema;
	config;
	text;
	nodeNameMap = {
		bold: "b",
		italic: "i",
		anchor: "a",
		code: "code",
		span: "span"
	};
	customInlineHandlers;
	constructor(e, t) {
		this.schema = e, this.config = t, this.text = "", this.customInlineHandlers = /* @__PURE__ */ new Map();
		for (let e of t?.customInlineHandlers ?? []) this.customInlineHandlers.set(e.name, e);
	}
	serializeNode(e) {
		let t = [];
		return e.content.forEach((e) => {
			let n = e.marks || [];
			n = this.filterSerializableMarks(n), this.maybeCloseMarks(t, n);
			let r = this.customInlineHandlers.get(e.type.name);
			if (r) {
				this.text += r.serialize(e, this);
				return;
			}
			switch (e.type) {
				case this.schema.nodes.hardBreak:
					this.text += "<br>";
					break;
				case this.schema.nodes.text:
					this.maybeOpenMarks(t, n), this.serializeText(e);
					break;
				case this.schema.nodes.template:
					this.maybeOpenMarks(t, n), this.serializeTemplate(e);
					break;
				case this.schema.nodes.mention:
					this.serializeMention(e);
					break;
				case this.schema.nodes.aiPromptData:
					this.serializeAiPromptData(e);
					break;
				case this.schema.nodes.marker: break;
				case this.schema.nodes.inlineImage:
					this.serializeImage(e);
					break;
				default: throw Error("Invalid node type in text");
			}
		}), this.maybeCloseMarks(t, []), this.text;
	}
	filterSerializableMarks(e) {
		return e.filter((e) => e.type.spec.serializable !== !1);
	}
	maybeCloseMarks(e, t) {
		if (e.filter((e) => !t.includes(e)).length === 0) return;
		let n = e.pop();
		if (!n) throw Error("unreachable");
		this.addClosingTag(n.type), this.maybeCloseMarks(e, t);
	}
	maybeOpenMarks(e, t) {
		t.filter((t) => !e.includes(t)).forEach((t) => {
			e.push(t), this.addOpeningTag(t);
		});
	}
	serializeText(e) {
		let r = e.text ?? "";
		t() || (r = n(r)), this.config?.plaintextSerialization ? this.text += this.handlePlaintextSerialization(r) : this.text += this.escape(r);
	}
	handlePlaintextSerialization(e) {
		let { entityHandling: t = "escape", sanitize: n = !1 } = this.config.plaintextSerialization ?? {};
		switch (t) {
			case "unescape": {
				let t = o(e);
				return typeof n == "function" ? n(t) : t;
			}
			case "textContent": return a(e);
			default: return this.escape(e);
		}
	}
	serializeTemplate(e) {
		this.text += `{{${this.escape(e.attrs.attributePath)}`, e.attrs.fallback && (this.text += `|fallback:"${this.escape(e.attrs.fallback)}"`), this.text += "}}";
	}
	serializeMention(t) {
		this.text += `<a class="${e}" href="${this.escape(t.attrs.uri)}">${this.escape(t.attrs.name)}</a>`;
	}
	serializeAiPromptData(e) {
		let t = "<span data-ai-prompt-data";
		Object.entries(e.attrs).forEach(([e, n]) => {
			if (n) {
				let r = e.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
				t += ` data-prompt-data-${r}="${this.escape(n)}"`;
			}
		}), this.text += `${t}></span>`;
	}
	serializeImage(t) {
		let { displayWidth: n, width: r, src: i, linkUrl: a, text: o, className: s } = t.attrs, c = `<img class="${e} inline-image" src="${this.escape(i)}" width="${n || r}"${o ? ` alt="${this.escape(o)}"` : ""}${s ? ` data-class-name="${this.escape(s)}"` : ""}>`;
		a && (c = `<a href="${this.escape(a)}">${c}</a>`), this.text += c;
	}
	addClosingTag(e) {
		this.text += `</${this.nodeNameMap[e.name]}>`;
	}
	addOpeningTag(e) {
		this.text += `<${this.nodeNameMap[e.type.name]}`, e.attrs && this.addAttrs(e), this.text += ">";
	}
	addAttrs(e) {
		Object.keys(e.attrs).forEach((t) => {
			let n = r(e.attrs[t]), i = this.escape(n);
			i && (this.text += ` ${t}="${i}"`);
		});
	}
	escape(e) {
		return i(e);
	}
};
//#endregion
export { s as TextSerializer };
